var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideDecoration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_786",
    "data-name": "Group 786",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_784",
    "data-name": "Rectangle 784",
    width: 36,
    height: 36,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_785",
    "data-name": "Group 785",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M35.069,18a16.508,16.508,0,0,0-1.344-6.614,17.2,17.2,0,0,0-9.111-9.111A16.525,16.525,0,0,0,18,.931a16.627,16.627,0,0,0-6.657,1.344,17.059,17.059,0,0,0-5.419,3.67,17.5,17.5,0,0,0-3.648,5.441A16.509,16.509,0,0,0,.931,18a16.627,16.627,0,0,0,1.344,6.657,17.044,17.044,0,0,0,9.068,9.068A16.627,16.627,0,0,0,18,35.069a16.525,16.525,0,0,0,6.614-1.344,17.5,17.5,0,0,0,5.441-3.648,17.059,17.059,0,0,0,3.67-5.419A16.615,16.615,0,0,0,35.069,18",
    fill: "#e0e6f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M23.882,18a5.687,5.687,0,0,0-.464-2.279,5.926,5.926,0,0,0-3.14-3.14,5.869,5.869,0,0,0-4.572,0,5.886,5.886,0,0,0-1.868,1.265,6.03,6.03,0,0,0-1.257,1.874,5.877,5.877,0,0,0,0,4.573,5.871,5.871,0,0,0,3.125,3.125,5.877,5.877,0,0,0,4.573,0,6.022,6.022,0,0,0,1.875-1.257,5.883,5.883,0,0,0,1.264-1.868A5.727,5.727,0,0,0,23.882,18",
    fill: "#0073b2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideDecoration);
export default __webpack_public_path__ + "static/media/side_decoration.a51b11c5fd34cdd0cc75d7fee0f19ec3.svg";
export { ForwardRef as ReactComponent };